module.exports = __webpack_public_path__ + "static/media/invoices-posting.4e7a1d07.svg";